export default __webpack_public_path__ + "static/media/Consulting.669aef13.png";